import { Button, Card, Input, Logo, useToast } from '@pharmaconnect/ui/web'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import { useTranslation } from '../i18n/I18nProvider'
import { supabase } from '../lib/supabase'

export function ForgotPasswordPage() {
  const { t } = useTranslation()
  const toast = useToast()
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email.trim()) return
    setLoading(true)
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
        redirectTo: `${window.location.origin}/reset-password`,
      })
      if (error) throw error
      setSent(true)
      toast.success(t('forgot.sent_title'))
    } catch (err) {
      // Toujours afficher le même message (anti-énumération de comptes)
      setSent(true)
      toast.success(t('forgot.sent_title'))
      // eslint-disable-next-line no-console
      console.warn('reset password error:', err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-pharmacist-bg px-4 py-8">
      <div className="mb-6">
        <Logo size={56} tone="dark" />
      </div>
      <Card className="w-full max-w-sm" noPadding>
        <div className="border-b border-white/10 p-6">
          <h1 className="text-xl font-bold text-pharmacist">{t('forgot.title')}</h1>
          <p className="mt-1 text-xs text-neutral-400">{t('forgot.subtitle')}</p>
        </div>

        {sent ? (
          <div className="flex flex-col gap-4 p-6" data-testid="sent">
            <p className="text-sm text-neutral-300">
              📧 {t('forgot.sent_message', { email })}
            </p>
            <Link
              to="/login"
              className="text-center text-sm text-pharmacist hover:underline"
              data-testid="back-to-login"
            >
              {t('forgot.back_to_login')}
            </Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="flex flex-col gap-4 p-6" data-testid="forgot-form">
            <Input
              label={t('common.email')}
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="vous@pharmaconnect.cm"
              required
              data-testid="email-input"
            />
            <Button type="submit" loading={loading} fullWidth disabled={!email.trim()}>
              {t('forgot.send_link')}
            </Button>
            <Link
              to="/login"
              className="text-center text-sm text-neutral-400 hover:text-pharmacist hover:underline"
            >
              {t('forgot.back_to_login')}
            </Link>
          </form>
        )}
      </Card>
    </main>
  )
}
